/// <reference path="Assistant.ts" />

namespace TerminalApp {

    export class PickAssistant<TCallback> extends Assistant {
        dm_menu = document.createElement("div");
        dm_inactive_container = document.createElement("div");
        dm_active_container = document.createElement("div");
        resultCount = 0;
        callback: (item: TCallback) => void;
        constructor(headline: string) {
            super();
            this.dm_menu.innerHTML = `<h1>${headline}</h1>`;
            this.dm_menu.append(this.dm_active_container);
            this.dm_menu.append(this.dm_inactive_container);
            this.container.appendChild(this.dm_menu);
        }

        hide() {
            this.dm_menu.style.display = "none";
        }

        open_dm_picker() {


            this.hide();
            this.container.style.display = "block";
            this.dm_menu.style.display = "block";
        }

        clear() {
            //clear home buttons
            this.dm_active_container.innerHTML = "";
            this.dm_inactive_container.innerHTML = "";
            this.container.style.display = "none";
        }

        async open(callback: (item: TCallback) => void) {
            this.callback = callback;
            this.open_dm_picker();
        }




        addItem(item: TCallback, active: boolean, title: string, descrpition: string, icon: string = null, color: string = null, speical_callback: (item: TCallback) => void = null) {
            var c = document.createElement("div");
            c.classList.add("btn", "noselect");

            if (!active) c.classList.add("inactive");

            if (icon) c.innerHTML = `<div class='icon fa' style='color:${color ?? "black"}'><i class="${icon}"></i></div>`;
            c.innerHTML += `<div class='action'>${title}</div>${descrpition}`;

            c.addEventListener("click", () => {
                (speical_callback ?? this.callback)(item);
                this.close();
            });

            if (active)
                this.dm_active_container.appendChild(c);
            else
                this.dm_inactive_container.appendChild(c);
        }

    }



    interface KeyValuePair {
        key: string;
        value: string;
    }


    export class KeyValuePickAssistant extends PickAssistant<KeyValuePair> {
        setAll(items: { [key: string]: string }, headline: string, default_text: string, default_value: string) {

            this.clear();
            this.dm_menu.querySelector("h1").innerHTML = headline;

            if (default_text != null) {
                this.addItem({ key: default_value, value: default_text }, true, default_text, "");
            }

            for (var key in items) {
                this.addItem({ key: key, value: items[key] }, true, items[key], "");
            }
        }
        setAllFromArray(items: any[], headline: string, default_text: string, default_value: string) {
            this.clear();
            this.dm_menu.querySelector("h1").innerHTML = headline;

            if (default_text != null) {
                this.addItem({ key: default_value, value: default_text }, true, default_text, "");
            }

            for (var i = 0; i < items.length; i++) {
                var item = items[i];
                this.addItem({ key: item.key ?? "", value: item.value ?? "" }, true, item.value ?? "", "");
            }
        }
    }





}